module.exports = __webpack_public_path__ + "img/topbg.c6dae091.jpg";